import React, { useEffect, useState } from "react";
import { Search,Pencil,Trash2 } from "lucide-react";
import Loader from "../../components/Loader/Loader";
import { useDistributorStore } from "../../store/useDistributorStore";
import { Pagination} from '@mui/material';
import AddDistributorPopup from "../../components/Model/AddDistributorPopup";
import { useAuthStore } from "../../store/useAuthStore";
import { useDebounce } from "../../hooks/useDebounce";

const DistributorTable = () => {
    const { user } = useAuthStore();
    const USER_ROLE = user?.userDataObj?.role;
    const PAGE_SIZE = 10;
    const { fetchDistributors,fetchStatesList,fetchDistrictsList } = useDistributorStore();
    const [states,setStates] = useState([])
    const [districts,setDistricts] = useState([])
    const [distributors, setDistributors] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [showAddModel,setShowAddModel] = useState(false)
    const [filter, setFilter] = useState({
        limit: PAGE_SIZE,
        offset: currentPage,
        state_id: "",
        district_id: "",
        distributorNameAndMobile : "",
    })
    const [isLoading, setIsLoading] = useState(false);
    const [editData,setEditData] = useState({});
    // const debouncedSearchTerm = useDebounce(filter.distributorNameAndMobile, 800);
    const handlePageChange = (newPage) => {
      setCurrentPage(newPage);
    };

    const onClose = () => {
      setEditData(false)
      setShowAddModel(false)
    }

    const fetchData = async (params) => {
        setIsLoading(true);
        const res = await fetchDistributors(params);
        // console.log("--------------res",res);
        
        if (res.status) {
            setDistributors(res.data.distributorList);
            setTotalPage(res.data?.pagination?.totalPages || 0);
        } else {
            setDistributors([]);
        }
        setIsLoading(false);
    };

    const fetchStates = async () => {
      setIsLoading(true)
      const res = await fetchStatesList()

      if(res.status) {
        setStates(res.data)
      }
    }

    const fetchDistricts = async (state_id) => {
      let params = {state_id : state_id}
      const res = await fetchDistrictsList(params)

      if(res.status) {
        setDistricts(res.data)
      }
    }

    const searchFilterData = async () => {
     await  fetchData({
        state_id : filter.state_id || '',
        district_id : filter.district_id || '',
        searchText: filter.distributorNameAndMobile,
        limit : filter.limit,
        offset : 1
      });
      setCurrentPage(1);
    }
    useEffect(() => {
        fetchData({
          state_id : filter.state_id || '',
          district_id : filter.district_id || '',
          searchText: filter.distributorNameAndMobile,
          limit : filter.limit,
          offset : currentPage
        });
    }, []);

    useEffect(() => {
      fetchData({
        state_id : filter.state_id || '',
        district_id : filter.district_id || '',
        searchText: filter.distributorNameAndMobile,
        limit : filter.limit,
        offset : currentPage
      });
  }, [currentPage]);

    
    useEffect(() => {
      fetchStates()
    }, []);

    const resetFilters = async() => {
      setFilter({
        state_id: "",
        district_id: "",
        distributorNameAndMobile : "",
        limit : filter.limit,
        offset : 1
      });
      setCurrentPage(0);
    };

    useEffect(() => {
      if(filter.state_id) fetchDistricts(filter.state_id)
    }, [filter.state_id]);

    useEffect(() => {
      searchFilterData();
    },[filter.state_id, filter.district_id]);

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        searchFilterData();
      }
    };

    // console.log('state', filter.state_id)

      if(isLoading){
        return <Loader />
      }

    return (
      <>
        <div className="overflow-x-auto">
        <div className="flex justify-end gap-5 mb-3">
         <button
              onClick={() => setShowAddModel(true)}
              className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-emerald-600 bg-emerald-100 rounded-md hover:bg-emerald-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500"
            >
              Add Distributor
            </button>
          </div>
          <div className="flex flex-col md:flex-row items-center mb-4 space-y-2 md:space-y-0 md:space-x-4">

            <div className="flex flex-col md:flex-row md:items-center w-full">
              <div className="grid grid-cols-1 md:flex md:space-x-2 w-full gap-1 custom-grid">
                <select className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto"
                  value={filter.state_id}
                                onChange={(e) => setFilter({ ...filter, state_id: e.target.value })}>
                  <option value="">All State</option>
                                {
                                    states?.map((state) => {
                                        return <option key={state.state_id} value={state.state_id}>{state.state_name}</option>
                                    })
                                }

                </select>
                            <select className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto"
                  value={filter.district_id} disabled={!filter.state_id}
                                onChange={(e) => setFilter({ ...filter, district_id: e.target.value })}>
                  <option value="">All District</option>
                                {
                                    districts?.map((district) => {
                                        return <option key={district?.id} value={district.id}>{district?.name}</option>
                                    })
                                }

                </select>
                <div className="relative w-full md:w-[500px]">
                    <Search className="absolute left-1 top-2 h-5 w-5 text-gray-400" />
                    <input
                        type="text"
                        value={filter.distributorNameAndMobile}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => setFilter({ ...filter, distributorNameAndMobile: e.target.value })}
                        placeholder="Search by Dist name/mobile/code"
                        className="w-full pl-8 pr-1 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                    />
               </div>

                {/* <button className="w-full md:w-auto px-2 py-1 bg-emerald-500 text-white text-sm rounded-lg hover:bg-emerald-600 transition"
                 onClick={searchFilterData}
                >
                  Apply
                </button> */}

                <button
                  className="w-full md:w-auto px-2 py-1 border-2 border-gray-300 text-black rounded-lg hover:bg-gray-50"
                  onClick={resetFilters}>
                  Reset
                </button>

              </div>
            </div>
          </div>

          <div className="overflow-auto rounded-lg">
            <table className="min-w-full overflow-auto divide-y divide-gray-200 table-bordered">
              <thead>
                <tr className="bg-emerald-200">
                 <th className="p-3 text-left text-sm font-bold text-gray-700">
                    Distributor Name
                  </th>
                 <th className="p-3 text-left text-sm font-bold text-gray-700">
                    Distributor Code
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700">
                    Mobile
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700">
                    State
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700">
                    District
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700">
                    Last Order Date
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700">
                    Total Orders
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700">
                    Status
                  </th>
                  {
                    USER_ROLE === 4 && <><th className="p-3 text-left text-sm font-bold text-gray-700">
                    Edit
                  </th>
                  </>
                  }
                </tr>
              </thead>
                        {distributors?.length != 0 ?
                            (<tbody className="bg-white divide-y divide-gray-200">
                  {distributors.map((distributor, index) => {
                    return (
                      <tr
                        key={distributor?.user_id}
                        className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                      >
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                          {distributor?.distributor_name}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                          {distributor?.distributor_code || ''}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                        {distributor?.mobile}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                        {distributor?.state_name || 'N/A'}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                        {distributor?.district_name || 'N/A'}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                        {distributor?.last_order_date || 'N/A'}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                         {distributor?.total_orders || 0}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                         {distributor?.block_user == 0 ? 'ACTIVE' : 'BLOCKED'}
                        </td>
                        { USER_ROLE === 4 && <> 
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800" onClick={() => {
                          setEditData({
                            user_id : distributor?.user_id, 
                            mobile : distributor?.mobile ?? '', 
                            email : distributor?.email ?? '', 
                            firstName : distributor?.firstName ?? '', 
                            lastName : distributor?.lastName ?? '',
                            distributor_name: distributor?.distributor_name ?? '', 
                            address : distributor?.address ?? '', 
                            state_id : distributor?.state_id ?? '', 
                            district_id : distributor?.district_id ?? '',
                            contact_person: distributor?.contact_person ?? '',
                            gst_number : distributor?.gst_number ?? '',
                            block_user: distributor?.block_user ?? 1,
                            distributor_code : distributor?.distributor_code ?? '',
                          })
                          setShowAddModel(true)
                        }}>
                         {<Pencil size={16} className="cursor-pointer flex justify-center items-center" />}
                        </td>
                        </>
                        }
                      </tr>
                    );
                  })}
                            </tbody>) :
                            (<tbody>
                  <tr>
                                    <td className="p-3 whitespace-nowrap text-sm text-center text-gray-900" colSpan={8}>
                      No Distributors Available
                    </td>
                  </tr>

                            </tbody>)
                        }
            </table>
              <div className="flex justify-center py-4 mb-6">
                <Pagination
                  count={totalPage}
                  page={currentPage}
                  onChange={(event, value) => handlePageChange(value)}
                  variant="outlined"
                  shape="rounded"
                  color="primary"
                />
              </div>
              {
                showAddModel && <AddDistributorPopup onClose={onClose} editData={editData} fetchData={fetchData} filter={filter} setCurrentPage={setCurrentPage} />
              }
          </div>
        </div>
      </>
    );
};

export default DistributorTable;